// Auto-close notice (architecture sprint-13 §15, F3): GET /api/timer carries the latest auto-closed shift for
// 24 h; this shows one toast per shift id, acknowledged in localStorage (try/catch: private windows and
// blocked storage only lose the "once"). Mounted once in AppShell; renders nothing.
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useActiveShift } from '@/hooks/use-shifts';
import { clockIn } from '@/lib/shift-format';

export const SHIFT_NOTICE_ACK_KEY = 'tt-shift-notice-ack';

function readAck(): string | null {
  try {
    return window.localStorage.getItem(SHIFT_NOTICE_ACK_KEY);
  } catch {
    return null;
  }
}

function writeAck(shiftId: string): void {
  try {
    window.localStorage.setItem(SHIFT_NOTICE_ACK_KEY, shiftId);
  } catch {
    // Storage blocked: the notice may show again on the next page load.
  }
}

const shownThisPage = new Set<string>();

export function autoCloseMessage(endedAtIso: string, tz: string): string {
  return `Your shift was closed automatically at ${clockIn(endedAtIso, tz)}.`;
}

export function ShiftNoticeToast({ tz }: { tz: string | undefined }): null {
  const notice = useActiveShift()?.notice ?? null;
  useEffect(() => {
    if (!notice || !tz) return;
    if (shownThisPage.has(notice.shiftId) || readAck() === notice.shiftId) return;
    shownThisPage.add(notice.shiftId);
    writeAck(notice.shiftId);
    toast(autoCloseMessage(notice.endedAt, tz), { description: notice.projectName });
  }, [notice, tz]);
  return null;
}
